import React, { useCallback, useMemo } from 'react';
import { t } from '@lingui/macro';

import { AccordionItem } from '@rover/react-lib/src/components/lists/Accordion';
import { BrandLocalityServiceCitiesItem } from '@rover/rsdk/src/apiClient/latest/model/brandLocalityServiceCitiesItem';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import {
  HomePageFooterAccordionCollapsed,
  HomePageFooterAccordionExpanded,
} from './analyticsEvents';
import FooterLinkList from './FooterLinkList';

export type Props = {
  citiesAndNeighborhoodsLinks: BrandLocalityServiceCitiesItem[];
};

const CitiesAndNeighborhoodsLinks: React.FC<Props> = ({ citiesAndNeighborhoodsLinks }) => {
  const eventProperties = useMemo(() => ({ dropDownName: 'Find care in your city 📍' }), []);
  const handleAccordionToggle = useCallback(
    (isOpen: boolean) => {
      const EventCtor = isOpen ? HomePageFooterAccordionExpanded : HomePageFooterAccordionCollapsed;
      emitAnalyticsEvent(new EventCtor(eventProperties));
    },
    [eventProperties]
  );

  const mappedCityAndNeighboorhoodLinks = useMemo(
    () =>
      citiesAndNeighborhoodsLinks.map((item) => ({
        name: item.city ?? '',
        url: item.seoSearchPath ?? '',
      })),
    [citiesAndNeighborhoodsLinks]
  );

  return (
    <AccordionItem
      itemHeading={<>{t`Find care in your city`} 📍</>}
      itemBody={
        citiesAndNeighborhoodsLinks && (
          <FooterLinkList linkList={mappedCityAndNeighboorhoodLinks} numColumns={[2, 3, 6]} />
        )
      }
      onToggle={handleAccordionToggle}
      testID="footer-accordion-localities-links"
    />
  );
};

export default CitiesAndNeighborhoodsLinks;
